import { render, staticRenderFns } from "./TaxCustomerForm.vue?vue&type=template&id=165ef366&scoped=true"
import script from "./TaxCustomerForm.vue?vue&type=script&lang=js"
export * from "./TaxCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./TaxCustomerForm.vue?vue&type=style&index=0&id=165ef366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ef366",
  null
  
)

export default component.exports